<template>
  <div class="header">
    <languageSelector class="language" />
    <img :src="logoFilename" class="header__logo" />
    <span class="header__text">
      {{ $t("xpo.shipment.title") }}
    </span>
  </div>
</template>

<script>
import languageSelector from "@/components/LanguageSelector.vue";

export default {
  components: {
    languageSelector
  },
  name: "Header",
  props: {
    logoName: {
      required: true
    },
    logoImage: {
      required: false
    }
  },
  data: () => ({}),
  computed: {
    logoFilename() {
      try {
        if (this.logoImage !== undefined && this.logoImage !== null) {
          return this.logoImage;
        } else {
          return require("@/assets/logo-" + this.logoName + ".svg");
        }
      } catch (error) {
        return "";
      }
    }
  }
};
</script>

<style src="./css/common.css"></style>

<style scoped>
.header {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.language {
  grid-row: 1;
}

.header__logo {
  grid-row: 2;
  max-width: 8rem;
  max-height: 1.2rem;
}

.header__text {
  font-family: Roboto;
  grid-row: 2;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  color: #858585;
  text-align: right;
  padding-right: 10px;
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
  background-color: #f2f2f2;
}
</style>
